import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(20)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(60)} 0 ${rem(50)} 0;
    }
`;

export const Customers = styled.ul`
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: 1fr;

    @media (min-width: ${breakpoints.xs}px) {
        grid-template-columns: 1fr 1fr;
    }

    @media (min-width: ${breakpoints.sm}px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const Customer = styled.li`
    margin-bottom: ${rem(10)};
    color: ${({ theme }) => theme.colors.grey};

    @media (min-width: ${breakpoints.xs}px) {
        margin-left: 15%;
    }
`;

export const ShowMoreButton = styled.button`
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    width: 100%;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    margin-top: ${rem(20)};
`;
